import { useSelector } from 'react-redux';

import { RequestListContext } from './RequestList.context';

export const RequestListProvider = ({ useListQuery, children }) => {
  const isLoggedIn = useSelector((state) => state.user?.loggedIn);
  const { data = [], isLoading } = useListQuery({}, { skip: !isLoggedIn });
  return (
    <RequestListContext.Provider value={{ list: data, isLoading }}>
      {children}
    </RequestListContext.Provider>
  );
};
